'use strict';

function UnkownStoreError(store) {
  this.name = 'Unknown store';
  this.message = 'Unknown store ' + store;
}

UnkownStoreError.prototype = Error.prototype;

module.exports = UnkownStoreError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/errors/unknownStoreError.js
// module id = AG1j
// module chunks = 88